import { dispatch, state } from '__common/store';
import { resetKdTree } from '../cursor/utils/kdTreeStore';
import { terminateKeyboard } from '../../keyboardConfg';
import {
  CLEAR_TILTED_ROOF,
  RESET_CURSOR_STATE,
  RESET_PANELS_STATE,
  RESET_RUBBERBAND_STATE,
  BG_CLEAR_LOADED,
  CLEAR_BACKGROUND_REDUCER,
  CLEAR_ALL_MEASUREMENTS,
  } from 'actions';
import { resetPanelCenterTree } from '../panels/utils/panelsCenterStore';
import { resetRubberBandPreviewState } from '../rubberBand/rubberBandPreview';
import { isValidCoordinates } from '../background/utils/isValidCoordinates';

export function resetPanelEditorState() {
  const { app: { isUbuilderLite }, projectConfiguration: { productId, projectEnvConfig: { building_code, building_type }, projectVersion } } = state();
  
  resetRubberBandPreviewState();
  // Read this before CLEAR_BACKGROUND_REDUCER nulls the roof center.
  // A save loader, and SM Ascender's module-drawer update, can remount the
  // editor while that roof is still open. Clearing here deleted the lines.
  // Back still clears them: DEACTIVE_PANELS_EDITOR nulls the roof center
  // before this unmount runs.
  const background = state().background;
  const designStillOpen = !!(background && isValidCoordinates(background.cords));
  const saveLoadProject = state().saveLoadProject;
  const editorSwappedForSave = !!(saveLoadProject && (saveLoadProject.isLoading || saveLoadProject.isSaveProjectPending));
  dispatch(RESET_PANELS_STATE());
  dispatch(RESET_CURSOR_STATE());
  dispatch(RESET_RUBBERBAND_STATE());
  // dispatch(CLEAR_TILTED_ROOF(productId, building_code, building_type));
  // Do not CLEAR_TILTED_ROOF here. Creating a new project from the header
  // while the editor is open already dispatched SET_TILTED_ROOF('---');
  // CLEAR would then apply the RM version default ("1") and the next
  // panel editor would show 1 instead of ---.
  dispatch(CLEAR_BACKGROUND_REDUCER());
  dispatch(BG_CLEAR_LOADED());
  if (!editorSwappedForSave && !designStillOpen) {
    dispatch(CLEAR_ALL_MEASUREMENTS());
  }
  terminateKeyboard();
  resetKdTree();
  resetPanelCenterTree();
}
